<template>
    <div class="mx-5">
        <div class="wrapper-container mb-5">
            <p class="text-container text-center font-24 font-md-16 font-sm-12 font-weight-700 mb-5">
                {{ settingsPerm.companyLogoTitle }}
            </p>
            <div v-if="firstSlider" class="splide firstSlider mb-3" aria-label="Slider for company logos">
                <div class="splide__track">
                    <div class="splide__list splide_company_logo">
                        <div v-for="(data, i) in firstSlider.concat(firstSlider)" :key="'first_' + i" class="splide__slide p-4">
                            <div class="logo-container text-center">
                                <img :src="data['gdl-tab-logo-image-url']" alt="Company Logo" class="company-logo mx-2">
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>       
    </div>
</template>
    
    <script>
    import Splide from '@splidejs/splide';
    import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
    
    export default {
        name: "CompanyLogo",
    
        created() {
            this.firstSlider = JSON.parse(this.settingsPerm.companyLogoSectionRepeater);
            this.mount_splide();
        },
    
        mounted() {
        },
    
        data() {
            return {
                firstSlider: [],
                splide: null,
                bgColor: this.settingsPerm.boxBgColor,
                addBorder: this.settingsPerm.addBorder,
            };
        },
    
        props: {
            settingsPerm: Object
        },
    
        methods: {
            mount_splide: function () {
            let thiz = this;
            setTimeout(function () {
                if (!thiz.splide) {
                    // first slider
                    thiz.splide = new Splide('.firstSlider', {
                        classes: {
                            prev: 'splide__arrow--prev previmpres',
                            next: 'splide__arrow--next nextimpres',
                            arrow: 'splide__arrow arrowimpres',
                        },
                        type   : 'loop',
                        drag   : 'free',
                        focus  : 'center',
                        perPage: 6,
                        autoScroll: {
                            speed: 1,
                        },
                        breakpoints: {
                        768: { 
                            perPage: 5,
                        },
                        425: { 
                            perPage: 3,
                        },
                    },
                    });

                    // Mount the AutoScroll extension
                    thiz.splide.mount({ AutoScroll });

                }
            }, 100);
            },
        },
    };
</script>

<style scoped>
.company-logo {
    height: 48px;
    max-width: 100%;
    min-width: 80px;
    object-fit: contain;
    filter: grayscale(100%);
}

.text-container {
    max-width: 850px;
    margin: 0 auto; 
}

.wrapper-container {
    max-width: 1350px;
    margin: 0 auto; 
}

/* Tablet */
@media (max-width: 1024px) {
    .company-logo {
        height: 25px;
        min-width: 60px;
    }

    .text-container {
        max-width: 750px; 
    }

}

/* Mobile */
@media (max-width: 768px) {

    .text-container {
        max-width: 400px; 
    }

    .company-logo {
        height: 32px;
        min-width: 50px;
    }
    
}
</style>
